import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
import { RTL_HTML_ATTRS } from '../../tokens/direction.js';
const ThemeContext = createContext(null);
/**
 * Applies `.ds-light` for v1 light mode (RTL document defaults preserved).
 *
 * Also stamps `data-theme` unconditionally, and `data-brand`/`data-sidebar`
 * when passed — additive attributes v1's CSS never reads, consumed only by
 * the v2 `.sk-*` stylesheet (`../../css.ts`'s `generateV2Css()`) so a v2
 * page tree mounted under this provider gets light/dark parity and tenant
 * theming from the same mode state, without a second theme mechanism.
 */
export function ThemeProvider({ mode = 'dark', onModeChange, brand, sidebarPaint, children, }) {
    const setMode = (next) => {
        onModeChange?.(next);
    };
    return (_jsx(ThemeContext.Provider, { value: { mode, setMode }, children: _jsx("div", { className: mode === 'light' ? 'ds-light' : undefined, dir: RTL_HTML_ATTRS.dir, lang: RTL_HTML_ATTRS.lang, "data-theme": mode, "data-brand": brand, "data-sidebar": sidebarPaint, children: children }) }));
}
export function useTheme() {
    const ctx = useContext(ThemeContext);
    if (!ctx) {
        throw new Error('useTheme must be used within ThemeProvider');
    }
    return ctx;
}
//# sourceMappingURL=ThemeProvider.js.map